angular
  .module('nv.components.autocomplete-floating-label')
  .controller('nvAutocompleteFloatingLabelCtrl', autoCompleteFloatingLabelCtrl);

function autoCompleteFloatingLabelCtrl() {
  let self = this;

  self.searchText = null;

  // handles when self.items is undefined
  if (!self.items) {
    self.items = [];
  }

  function createFilterFor(query) {
    let lowercaseQuery = query.toLowerCase();
    return function filterFn(item) {
      let q = item.toLowerCase();
      return q.indexOf(lowercaseQuery) === 0;
    };
  }

  self.querySearch = function(query) {
    return query ? self.items.filter(createFilterFor(query)) : self.items;
  };

  self.selected = function() {
    self.onChange();
  };
}
